import React, {useEffect, useState} from "react";
import './app-settings-page.css';
import ActionButton from "../../components/ActionButton";
import {showlog} from "../../utils";
import {loadAppSettings, saveAppSettings} from "./app-settings-service";
import {AiConfig, AppSettings, DEFAULT_APP_SETTINGS} from "./static";

function AiConfigBox(props: { idPrefix: string; title: string; config: AiConfig; onChange: (config: AiConfig) => void; }) {

	const [showApiKey, setShowApiKey] = useState(false);
	const {idPrefix, title, config, onChange} = props;

	return (
		<div className="app-settings-section">
			<h2>{title}</h2>

			<div className="app-settings-field">
				<label htmlFor={`${idPrefix}-api-key`}>API Key</label>
				<div className="app-settings-input-with-action">
					<input
						id={`${idPrefix}-api-key`}
						type={showApiKey ? 'text' : 'password'}
						placeholder="Inserisci la API Key"
						value={config.apiKey}
						onChange={changeEvent => onChange({...config, apiKey: changeEvent.target.value})}
						autoComplete="off"
					/>
					<span
						className="app-settings-toggle-visibility"
						onClick={() => setShowApiKey(current => !current)}
					>
						{showApiKey ? 'Nascondi' : 'Mostra'}
					</span>
				</div>
				<span className="app-settings-hint">La API Key viene salvata cifrata sul server.</span>
			</div>

			<div className="app-settings-field">
				<label htmlFor={`${idPrefix}-model`}>Modello AI</label>
				<input
					id={`${idPrefix}-model`}
					type="text"
					placeholder="es. claude-sonnet-5"
					value={config.model}
					onChange={changeEvent => onChange({...config, model: changeEvent.target.value})}
					autoComplete="off"
				/>
			</div>
		</div>
	);
}

export function AppSettingsPage() {

	const [settings, setSettings] = useState<AppSettings>(DEFAULT_APP_SETTINGS);
	const [saved, setSaved] = useState(false);

	useEffect(() => {
		loadAppSettings().then(loadedSettings => setSettings(loadedSettings));
	}, []);

	function updateSection(section: keyof AppSettings, config: AiConfig) {
		setSaved(false);
		setSettings(current => ({...current, [section]: config}));
	}

	async function handleSave() {
		try {
			await saveAppSettings(settings);
			setSaved(true);
			return true;
		} catch (e) {
			showlog("error in handleSave()", e);
			throw e;
		}
	}

	return (
		<div className="app-settings-page">
			<h1>Impostazioni App</h1>

			<AiConfigBox
				idPrefix="assistant"
				title="Mobile Agent Assistant"
				config={settings.assistant}
				onChange={config => updateSection('assistant', config)}
			/>

			<AiConfigBox
				idPrefix="ocr"
				title="AI OCR"
				config={settings.ocr}
				onChange={config => updateSection('ocr', config)}
			/>

			<div className="app-settings-actions">
				<ActionButton
					buttonText="Salva"
					waitingText="Salvataggio..."
					action={handleSave}
				/>
				{
					saved && (
						<span className="app-settings-saved-label">Impostazioni salvate</span>
					)
				}
			</div>
		</div>
	);
}
